import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { IServerError } from 'js/hooks/socket/types';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

import * as constants from './constants';
import { IGNORE_LIMITS_NOTIFICATION } from 'js/hooks/socket/constants';

export const useHandleLimitsErrorNotification = () => {
    const dispatch = useDispatch();

    return useCallback((error: IServerError): void => {
        const { ID, data } = error;
        const tkPrefix = constants.TRANSLATIONS_MAP[ID];

        if (data.correlationId.startsWith(IGNORE_LIMITS_NOTIFICATION)) {
            return;
        }

        dispatch(showCommonPopupAction({
            title: `${tkPrefix}popupTitle`,
            content: `${tkPrefix}popupContent`
        }));
    }, [dispatch]);
};
